import {createSlice} from "@reduxjs/toolkit";

import {getHomeLayout, createHomeLayout, updateHomeLayout, deleteHomeLayout} from "./thunk";

export const initialState = {
    homeLayout: [],
    errors: {}
};

const HomeLayoutSlice = createSlice({
    name: 'HomeLayout',
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        builder.addCase(getHomeLayout.fulfilled, (state: any, action: any) => {
            state.homeLayout = action.payload;
        });
        builder.addCase(getHomeLayout.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(createHomeLayout.fulfilled, (state: any, action: any) => {
            state.homeLayout.unshift(action.payload);
        });
        builder.addCase(createHomeLayout.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(updateHomeLayout.fulfilled, (state: any, action: any) => {
            state.homeLayout = state.homeLayout.map((homeLayout: any) =>
                homeLayout.id === action.payload.id
                    ? {...homeLayout, ...action.payload}
                    : homeLayout
            );
        });

        builder.addCase(updateHomeLayout.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(deleteHomeLayout.fulfilled, (state: any, action: any) => {
            state.homeLayout = state.homeLayout.filter(
                (homeLayout: any) => homeLayout.id !== action.payload
            );
            console.log(action.payload)
        });
        builder.addCase(deleteHomeLayout.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
    }
});

export default HomeLayoutSlice.reducer;